import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IPlaceOfferInputModel } from '../../../shared/models/PlaceOfferInputModel';
import { IPropertyDetails } from '../../../shared/models/propertydetails';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-portfolio-place-offer',
    templateUrl: './portfolio-place-offer.component.html',
    styleUrls: ['./portfolio-place-offer.component.css']
})
export class PortfolioPlaceOfferComponent implements OnInit {

    constructor() { }
    @Input() propertyGuid: string;
    @Input() propType: number;
    @Input() IsFromPropertyView: boolean;
    @Input() property: IPropertyDetails;
    @Input() fromOfferMatrix: boolean = false;

    placeOfferInputModel = {} as IPlaceOfferInputModel;
    showFileUpload = true;
    showPlaceOfferScreen = false;
    modalRef: BsModalRef;
    propertyList: any = [];
    askingPrice: number;
    showItems = true;

    ngOnInit() {
        
        // To show the place offer screen on tclicking on the place offer near offer matrix
        if (this.fromOfferMatrix) {
            this.showItems = true;
            this.showPlaceOfferScreen = true;
        }
    }

    seletedProperties(data: any[]) {
        this.propertyList = data["propList"];
        this.askingPrice = data["askingPrice"];
    }

    offerPlaced(event) {
        this.showItems = false;
    }

    showPlaceOffer(event) {
        this.showPlaceOfferScreen = true;
    }
}
